import { Injectable } from '@angular/core';
import { AutenticacionService } from './autenticacion.service';
import { ConstantsService } from './constants.service';
import { ErrorsService } from './tools/errors.service';
import { ValidatorService } from './tools/validator.service';
import { Http } from '@angular/http';
@Injectable()
export class EsquemaInversionService {

  private service_url;

  constructor(
    private constantsService: ConstantsService,
    private http: Http,
    private authService: AutenticacionService,
    private validatorService: ValidatorService,
    private errorService: ErrorsService
  ) {
    this.service_url = this.constantsService.apiURL + '/esquema-inversion';
  }

  public validate(data){
    console.log("Valindando esquema... ", data);

    let error = [];

    if(!this.validatorService.required(data["tipo_producto"])){
      error["tipo_producto"] = this.errorService.required;
    }

    if(!this.validatorService.required(data["idProductoFinanciero"])){
      error["idProductoFinanciero"] = this.errorService.required;
    }

    if(!this.validatorService.required(data["monto"])){
      error["monto"] = this.errorService.required;
    }

    if(!this.validatorService.required(data["fecha_inicio_inversion"])){
      error["fecha_inicio_inversion"] = this.errorService.required;
    }

    if(!this.validatorService.required(data["fecha_fin_inversion"])){
      error["fecha_fin_inversion"] = this.errorService.required;
    }

    if(!this.validatorService.required(data["capitalizacion"])){
      error["capitalizacion"] = this.errorService.required;
    }

    if(!this.validatorService.required(data["retencion_impuestos"])){
      error["retencion_impuestos"] = this.errorService.required;
    }

    if(data["retencion_impuestos"] === "si"){
      if(!this.validatorService.required(data["tasa_retencion"])){
        error["tasa_retencion"] = this.errorService.required;
      }
    }

    return error;
  }

  public validateIncremento(data){
    console.log("validating... ", data);

    let error = [];

    if(!this.validatorService.required(data["fecha_incremento_inversion"])){
      error["fecha_incremento_inversion"] = this.errorService.required;
    }

    if(!this.validatorService.required(data["monto_incremento"])){
      error["monto_incremento"] = this.errorService.required;
    }

    return error;
  }

  public validateDevolucion(data){
    console.log("validating... ", data);

    let error = [];

    if(!this.validatorService.required(data["tipo_retiro"])){
      error["tipo_retiro"] = this.errorService.required;
    }
    if(!this.validatorService.required(data["fecha_devolucion_inversion"])){
      error["fecha_devolucion_inversion"] = this.errorService.required;
    }

    if(!this.validatorService.required(data["monto_retiro"])){
      error["monto_retiro"] = this.errorService.required;
    }

    return error;
  }

  getDefaultSchedule() {
    return {
      'idFondeador': '',
      'tipo_producto':'',
      'idProductoFinanciero':'',
      'monto':'',
      'fecha_inicio_inversion': '',
      'fecha_fin_inversion': '',
      'volante_apertura': '',
      'capitalizacion': '',
      'retencion_impuestos': '',
      'tasa_retencion': '',
    };
  }

  getDefaultScheduleIncremento() {
    return {
      'idEsquemaInversion': '',
      'idFondeador': '',
      'fecha_incremento_inversion':'',
      'num_referencia':'',
      'monto_incremento':'',
      'total_inversion':'',
      'pago_interes':''
    };
  }

  getDefaultScheduleDevolucion() {
    return {
      'idEsquemaInversion': '',
      'idFondeador': '',
      'tipo_retiro':'',
      'fecha_devolucion_inversion':'',
      'num_referencia':'',
      'monto_retiro':'',
      'pago_penalizacion':'',
      'condonacion':''
    };
  }

  public registrarEsquema(data) {
    return this.http.post(this.service_url, data, this.authService.getAuthHeaders());
  }

  public getEsquemasInversion(){
    //return this.http.get(this.service_url+"/lista-fondeadores?", this.authService.getAuthHeaders());
  }

  //Agregar incremento de inversión
  public agregarIncremento(data) {
    return this.http.post(this.service_url+"/incremento", data, this.authService.getAuthHeaders());
  }
  //Retirar fondos de la inversión
  public devolucionEnInversion(data) {
    return this.http.post(this.service_url+"/devolucion", data, this.authService.getAuthHeaders());
  }

  public getRetiroPorID(id: number) {
    return this.http.get(this.service_url+"/devolucion?idRetiro="+id, this.authService.getAuthHeaders());
  }

  public updateRetiro(data: any, id: number) {
    return this.http.put(this.service_url+"/devolucion?idRetiro="+id, data, this.authService.getAuthHeaders());
  }

  public deleteRetiro(id: number) {
    return this.http.delete(this.service_url+"/devolucion?idRetiro="+id, this.authService.getAuthHeaders());
  }

  public finalizarEsquemaInversion(data: any){
    return this.http.put(this.service_url+"/completado", data, this.authService.getAuthHeaders());
  }

  public eliminarEsquema(data:any){
    return this.http.post(this.service_url+"/eliminar?id="+data.id,data, this.authService.getAuthHeaders());
  }

  public guardarestimado(data:any){
    return this.http.post(this.service_url+"/estimados", data, this.authService.getAuthHeaders());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/esquema-inversion.service.ts